/** Validaciones puras de códigos de producto (SKU / barcode). */

export const normalizeProductCode = (code: string) => code.trim().toUpperCase();

/** Matches `products_org_sku_uidx` / barcode unique indexes: blank codes are not unique. */
export function productCodeUniquenessKey(code: string | null | undefined): string | null {
  const trimmed = (code ?? '').trim();
  return trimmed ? normalizeProductCode(trimmed) : null;
}

/**
 * Quita espacios, tabs, NBSP y caracteres invisibles que Excel deja en celdas de barcode.
 * No altera letras/dígitos del código.
 */
export function sanitizeBarcodeCsvCell(raw: string | undefined): string {
  if (raw == null) return '';
  return raw
    .replace(/^\uFEFF/, '')
    .replace(/[\s\u00a0\u200b-\u200d\u202f\u2060\ufeff]+/g, '')
    .trim();
}

export const validateSku = (code: string) => {
  const normalized = normalizeProductCode(code);

  if (!normalized) {
    return null;
  }

  if (!/^[A-Z0-9._-]+$/.test(normalized)) {
    return 'Usá solo letras, números, puntos o guiones.';
  }

  if (normalized.length < 2) {
    return 'El código debe tener al menos 2 caracteres.';
  }

  return null;
};

export const validateBarcode = (code: string) => {
  const normalized = normalizeProductCode(code);

  if (!normalized) {
    return null;
  }

  if (!/^[A-Z0-9]+$/.test(normalized)) {
    return 'Usá solo letras y números.';
  }

  if (/^\d+$/.test(normalized) && ![8, 12, 13, 14].includes(normalized.length)) {
    const n = normalized.length;
    const excelHint =
      n === 10 || n === 11 ? ' Excel suele borrar un cero al inicio o al final.' : '';
    return `Código de barras: ${n} dígitos (se aceptan 8, 12, 13 o 14).${excelHint}`;
  }

  return null;
};
